import { Stack } from '@mui/material'

import CustomTooltip from 'components/shared/CustomTooltip'
import { IGroupEntity } from 'models'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { ReactComponent as FoodIcon } from '../../assets/food_icon.svg'
import { ReactComponent as GroupCowLogo } from '../../assets/group_cow_logo.svg'

type GroupInfoProps = IGroupEntity & {
	hasFoodTableLicense?: boolean
}

const GroupInfo = ({
	hasFoodTableLicense = false,
	...props
}: GroupInfoProps) => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const isCattleQtyOverLimit =
		props.cattles_limit != null && props.cattles_qty > props.cattles_limit
	const showKsInfo = Boolean(
		permissions?.license_food_table && hasFoodTableLicense,
	)

	return (
		<Stack direction='column' sx={{ gap: '18px' }}>
			<Stack direction='row' alignItems='center' justifyContent='space-between'>
				<Stack direction='row' alignItems='center' gap='4px'>
					<GroupCowLogo />
					<TypographySecondary14>Голов в группе:</TypographySecondary14>
					<TypographyPrimary
						sx={{ color: isCattleQtyOverLimit ? COLORS.error : undefined }}
					>
						{props.cattles_qty}
					</TypographyPrimary>
					{props.cattles_limit && (
						<>
							<TypographySecondary14>{`/ ${props.cattles_limit}`}</TypographySecondary14>
							<CustomTooltip
								width={'16px'}
								height={'16px'}
								info={true}
								placement={'top'}
								title={'Вместимость группы '}
							/>
						</>
					)}
				</Stack>
				{/* {permissions?.license_identification && (
					<Stack direction='row' alignItems='center' gap='4px'>
						<TypographySecondary14>Лактационный период:</TypographySecondary14>
						{props.lactation_period && (
							<TypographyPrimary>{props.lactation_period}</TypographyPrimary>
						)}
					</Stack>
				)} */}
			</Stack>
			{showKsInfo && (
				<Stack direction='row' alignItems='center' gap='4px'>
					<FoodIcon /> <TypographySecondary14>Рацион:</TypographySecondary14>
					<TypographyPrimary
						sx={{ color: props.rationtitle ? undefined : COLORS.error }}
					>
						{props.rationtitle ? props.rationtitle : 'Не назначен'}
					</TypographyPrimary>
				</Stack>
			)}
		</Stack>
	)
}

export default GroupInfo
